import {
  Box,
  Card,
  Grid,
  Stack,
  Typography,
  LinearProgress,
  Divider,
  Button,
  List,
  Chip,
  ListItem,
  ListItemText,
  Paper
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import InsightsIcon from '@mui/icons-material/Insights';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import StarRateIcon from '@mui/icons-material/StarRate';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import EventNoteIcon from '@mui/icons-material/EventNote';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getSummaryList } from '../../store/Slice/Payout/PayoutSlice';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import { getLoginData } from '../../store/Slice/Login/LoginSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { fDate } from '../../utils/formatTime';
import Label from '../../components/Label';

function Summary() {
  const [targets, setTargets] = useState({
    monthly: { target: 5000000, achieved: 3500000 },
    quarterly: { target: 15000000, achieved: 10500000 },
    yearly: { target: 60000000, achieved: 42000000 }
  });

  const { LoginData } = useLoginSelector();
  const { PayoutSummaryData } = usePayoutSelector();

  // console.log('PayoutSummaryData', PayoutSummaryData);

  const advanceRequests = PayoutSummaryData?.advances;

  const pct = (achieved, target) => {
    if (target === 0) return 0;
    return Math.round((achieved / target) * 100);
  };

  const dispatch = useDispatch();

  const getSummaryListApi = async () => {
    const credentials = {
      userId: LoginData?.userId
    };
    const result = await dispatch(getSummaryList(credentials));
    console.log(result);
  };

  useEffect(() => {
    getSummaryListApi();
  }, []);

  const getIconColor = (s) =>
    ({
      'Total Amount Earned': 'info',
      'Amount Pending': 'info',
      'Amount Failed': 'info',
      'Total Files': 'info'
    }[s] || 'info');

  const summaryCards = [
    LoginData?.userType !== 'ADMIN' && {
      label: 'Total Amount Earned',
      value: PayoutSummaryData?.accountOverview?.commissionEarned,
      icon: '₹'
    },
    {
      label: 'Average Monthly Business',
      value: PayoutSummaryData?.summary?.averageMonthlyBusiness,
      icon: '📊'
    },
    {
      label: 'Total Files',
      value: PayoutSummaryData?.summary?.totalFiles,
      icon: '📁'
    },
    {
      label: 'Success Ratio',
      value: `${PayoutSummaryData?.summary?.successRatio}%`,
      icon: '✅'
    }
  ].filter(Boolean);

  return (
    <Box sx={{ px: 2 }}>
      <Grid container spacing={2} pt={5} mb={3}>
        {summaryCards?.map((card, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Paper
              elevation={1}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 1,
                borderRadius: 2,
                border: '1px solid #f7f5f5',
                height: '100%'
              }}
            >
              <Label
                style={{ borderRadius: '10px', height: '50px', width: '50px', fontSize: '24px' }}
                variant="ghost"
                color={getIconColor(card.label)}
              >
                {card?.icon}
              </Label>
              <Box>
                <Typography fontSize={22} fontWeight={700}>
                  {card?.value || '0'}
                </Typography>
                <Typography color="text.secondary"> {card?.label}</Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3} alignItems="stretch">
        {/* -------- SUMMARY CARDS -------- */}

        {/* <Grid item xs={12} md={6}>
          <Typography
            style={{ marginTop: '30px' }}
            variant="body1"
            className="headingLineUp headingLineUpOut"
          >
            Account Overview
          </Typography>

          <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3}>
            <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} marginBottom={3}>
              <Grid item xs={12} sm={6} md={6}>
                <Box className="displayFlex">
                  <TrendingUpIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Total Business (YTD)</Typography>
                    <Typography className="labelText">
                      {PayoutSummaryData?.accountOverview?.totalBusinessYTD}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Box className="displayFlex">
                  <CurrencyRupeeIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Commission Earned</Typography>
                    <Typography className="labelText">
                      {PayoutSummaryData?.accountOverview?.commissionEarned}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Box className="displayFlex">
                  <AccountBalanceWalletIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Amount to be Recovered</Typography>
                    <Typography className="labelText">
                      {PayoutSummaryData?.accountOverview?.amountToBeRecovered}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={6}>
                <Box className="displayFlex">
                  <InsightsIcon className="viewLabelIcon" />
                  <Box ml={1}>
                    <Typography className="labelValue">Partner LTV</Typography>
                    <Typography className="labelText">
                      {PayoutSummaryData?.summary?.successRatio}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid> */}
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <Card sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography
              style={{ marginTop: '30px', width: 'fit-content' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              FCR Overview
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3} sx={{ flexGrow: 1 }}>
              <Grid container spacing={{ xs: 1, sm: 2, md: 2 }} marginBottom={3}>
                <Grid item xs={12} sm={6} md={6}>
                  <Box className="displayFlex">
                    <WorkspacePremiumIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Partner Category</Typography>
                      <Typography className="labelText">Gold</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Box className="displayFlex">
                    <StarRateIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Partner Rating</Typography>
                      <Typography className="labelText">4.8/5.0</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Box className="displayFlex">
                    <LeaderboardIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Partner Rank</Typography>
                      <Typography className="labelText">#12</Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Box className="displayFlex">
                    <CreditScoreIcon className="viewLabelIcon" />
                    <Box ml={1}>
                      <Typography className="labelValue">Partner Credit Limit</Typography>
                      <Typography className="labelText">₹1,000,000</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <Card sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography
              style={{ marginTop: '30px', width: 'fit-content' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              Target vs Achievement
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3} sx={{ flexGrow: 1 }}>
              <Grid container marginBottom={3}>
                <Box>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 1 }}
                  >
                    <Box>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 700,
                          fontFamily: '"Poppins", sans-serif'
                        }}
                      >
                        Monthly
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#6b7280' }}>
                        Active month target & achievement
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        ₹{targets.monthly.achieved.toLocaleString('en-IN')} / ₹
                        {targets.monthly.target.toLocaleString('en-IN')}
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#6b7280' }}>
                        {pct(targets.monthly.achieved, targets.monthly.target)}%
                      </Typography>
                    </Box>
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    value={pct(targets.monthly.achieved, targets.monthly.target)}
                    sx={{ height: 10, borderRadius: 2 }}
                  />
                </Box>
                <Box mt={3}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ mb: 1 }}
                  >
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Quarterly
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#6b7280' }}>
                        Current quarter progress
                      </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        ₹{targets.quarterly.achieved.toLocaleString('en-IN')} / ₹
                        {targets.quarterly.target.toLocaleString('en-IN')}
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#6b7280' }}>
                        {pct(targets.quarterly.achieved, targets.quarterly.target)}%
                      </Typography>
                    </Box>
                  </Stack>
                  <LinearProgress
                    variant="determinate"
                    value={pct(targets.quarterly.achieved, targets.quarterly.target)}
                    sx={{ height: 10, borderRadius: 2 }}
                  />
                </Box>
              </Grid>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <Card sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography
              style={{ width: 'fit-content' }}
              variant="body1"
              className="headingLineUp headingLineUpOut"
            >
              Advance List
            </Typography>

            <Box className="viewLeadCard cardTopMinusMargin" mt={5} mb={3} sx={{ flexGrow: 1 }}>
              <Grid container>
                <Stack spacing={2}>
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      Credit Summary
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#6b7280',
                        display: 'block',
                        mb: 1
                      }}
                    >
                      Limit / Used / Available
                    </Typography>

                    <Stack direction="row" spacing={2} alignItems="center">
                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          {PayoutSummaryData?.creditSummary?.creditLimit}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#6b7280' }}>
                          Credit Limit
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          {PayoutSummaryData?.creditSummary?.used}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#6b7280' }}>
                          Used
                        </Typography>
                      </Box>

                      <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                          {PayoutSummaryData?.creditSummary?.available}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#6b7280' }}>
                          Available
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>

                  <Divider />

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      Recent Advance Requests
                    </Typography>
                    {/* <Button
                      size="small"
                      variant="contained"
                      // onClick={() => setOpenAdvanceModal(true)}
                    >
                      Request Advance
                    </Button> */}
                  </Box>

                  <List dense sx={{ maxHeight: 220, overflow: 'auto' }}>
                    {!advanceRequests && (
                      <ListItem>
                        <ListItemText
                          primary="No advance requests"
                          secondary="No requests have been made."
                        />
                      </ListItem>
                    )}
                    {advanceRequests &&
                      advanceRequests.slice(0, 3).map((r) => (
                        <ListItem
                          key={r.partnerAdvanceId}
                          secondaryAction={<Chip label={r.approvalStatus} size="small" />}
                        >
                          <ListItemText
                            primary={`ADV-${r.partnerAdvanceId} • ₹${r.requestAmount.toLocaleString(
                              'en-IN'
                            )}`}
                            secondary={`${fDate(r.requestDate)} • ${r.purpose}`}
                          />
                        </ListItem>
                      ))}
                  </List>

                  <Box sx={{ pt: 1 }}>
                    <Typography variant="caption" sx={{ color: '#6b7280' }}>
                      Note: Advances are subject to credit policy and verification. Pending requests
                      will be reviewed by the credit team.
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Summary;
